import { useContext, useState, useEffect } from "react"
import { UserContext } from "../context/UserProvider"
import { Navigate } from "react-router-dom"
import { Api } from '../componentes/Api';


const VerificarUsuario = ({ children, Rol, SubRol }) => {
    const { user } = useContext(UserContext)
    const [Roles, setRoles] = useState([])
    let dt = JSON.parse(user)

    const GetAsignacionModulo = async (u) => {
        let response = await fetch(Api + "Administracion/GetAsignacionModulo/" + u);
        if (response.ok) {
            let data = await response.json()
            setRoles(data)


        }
    }

    setTimeout(() => {
        GetAsignacionModulo(dt.idUsuario)

    }, 5000);

 
  


    var v = Roles.filter(x => x.moduloID == Rol && x.opcionMenu == SubRol).map(x => { return true });
    if (v.length == 0) {
        return false;
    } else { return children; }

    if (user == null) {
        return <Navigate to="/Login" />
    }
    return children
}

export default VerificarUsuario